var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "panel pt-1 w-100",
      class: { "panel-with-footer": !_vm.isLoading }
    },
    [
      _c(
        "div",
        { staticClass: "panel-body-lg pb-3" },
        [
          _c("news-feed", {
            attrs: {
              title: "<h2>News based on your interests<h2>",
              posts: _vm.posts,
              topics: _vm.topics,
              "is-loading": _vm.isLoading,
              "is-errored": _vm.isErrored,
              "is-full-page": false,
              "enable-edit-interests": true
            },
            on: { interestsSaved: _vm.initializeNewsByInterests }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isLoading && !_vm.isErrored
        ? _c(
            "div",
            { staticClass: "panel-footer-wrapper" },
            [
              _c("panel-footer", {
                attrs: {
                  text: "View all news",
                  "router-link-to": { path: "news-by-interests" },
                  "event-name": "News by interest panel view all clicked"
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04f01380", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f01380","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/newsByInterests/NewsByInterests.vue
// module id = null
// module chunks = 